module.exports = __webpack_public_path__ + "d8d596ce41228b9c47e3a66f9cc8d9ea.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/all-bold.svg
// module id = hU0a
// module chunks = 0